import { Component, OnInit } from '@angular/core';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValueSet, LocalService, PageKey, Paging } from '../../../service/local.service';

@Component({
  selector: 'app-facts',
  templateUrl: './facts.component.html',
  styleUrls: ['./facts.component.scss']
})
export class FactsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["common"];
  timeLeft: number = 0; 
  item = ''; isTimerStarted = false; iRefreshCount: number = 10; iRefreshCountCurrent: number = 0;
  items: string[]; paging: Paging; isFlashFound: boolean = false;
  constructor(public localService: LocalService, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onRefresh();
  }

  onRefresh() {
    if (this.paging) {
      this.paging.currentPage = this.paging.currentPage == this.paging.totalPage ? 1 : this.paging.currentPage + 1;
    }
    this.configurationManagementService.getOnlyLanguagesConfig(PageKey.Tips, this.paging ? this.paging : null, true, false).subscribe(result => {
      if (result && result.items && result.items.length > 0) {
        this.paging = result.paging;
        this.items = result.items.map(x => x.v1);
        this.isFlashFound = result.items.filter(x => x.v2 == "1").length > 0;
        this.iRefreshCountCurrent = 0;
        if (!this.isTimerStarted) {
          this.item = this.items[0];
          this.isTimerStarted = true;
        }
      }
    });
  }
}
